import Api from "./Api";

const toQuery = (params = {}) =>
  Object.keys(params)
    .filter(
      (key) =>
        params[key] !== undefined && params[key] !== null && params[key] !== "",
    )
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join("&");

export default {
  // filters: status, job_type, cinema_id, source_cinema_id, resend_status, trigger_source,
  // from_date, to_date, search, include_history, limit, currentPage
  GetOdooApiLogs(params = {}) {
    return Api().get(`/odoo/api-logs?${toQuery(params)}`);
  },
  GetOdooApiLogsSummary(params = {}) {
    return Api().get(`/odoo/api-logs/summary?${toQuery(params)}`);
  },
  GetOdooApiLogDetail(requestUid) {
    return Api().get(`/odoo/api-logs/${encodeURIComponent(requestUid)}`);
  },
  // payload: { request_uids: [], mode: "RERUN" | "REPLAY", force: boolean }
  ResendOdooApiLogs(payload) {
    return Api().post(`/odoo/api-logs/resend`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/OdooLogsService.js